import { PortableTextReactComponents } from '@portabletext/react'
import styles from './GlobalNewsletterModal.module.scss'
import RichText from '@/components/RichText/RichText'

const portableTextSerializer: Partial<PortableTextReactComponents> = {
  types: {},
  block: {
    normal: ({ children }) => <p className={styles.header}>{children}</p>,
  },
  marks: {
    redText: ({ text }) => {
      return <span className={styles.redText}>{text}</span>
    },
  },
}

interface HeaderProps {
  content: any // TODO: Replace with proper Sanity content type
}

function Header({ content }: HeaderProps) {
  return (
    <RichText
      value={content}
      components={portableTextSerializer}
    />
  )
}

export default Header
